module.exports = "https://s.pinimg.com/webapp/style/images/SK@2x-5ec50037.png";